import React from 'react'

const LoadingCar = () => {
  return <img src='images/loading-animation.gif' alt='loading' />
}

export default LoadingCar